<div style="overflow-y: auto" mdbModal #agregarMasivos="mdb-modal" class="modal fade" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" (closed)="closeModal()"
  [config]="{ backdrop: isLoading, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="max-width: 90%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Carga masiva de {{tipo | lowercase}}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="agregarMasivos.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div style="border-bottom: 1px solid #dee2e6" class="mt-2 d-flex">
          <h5 class="mr-auto align-self-center">
            Detalle del archivo
          </h5>
          <a mdbBtn [href]="urlDownloadPlantilla" [download]="nombrePlantilla" target="_blank" role="button" color="dark-green" mdbWavesEffect class="m-1">
            <mdb-icon fas icon="file-excel" class="mr-1"></mdb-icon>
            Descargar Plantilla
          </a>
        </div>

        <div class="row">
          <div class="col">
            <div class="file-field md-form">
              <div mdbBtn color="default" size="sm" class="waves-light" mdbWavesEffect>
                <span>Buscar archivo</span>
                <input type="file" mdbFileSelect (change)="onFileSelect($event)"
                  [multiple]="false"
                  [accept]="accept">
              </div>
              <div class="file-path-wrapper">
                <input class="file-path" type="text" readonly placeholder="Archivo seleccionado" [value]="showFiles()">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="alert alert-info" role="alert" *ngIf="procesadoFinalizado">
              <strong>Proceso finalizado:</strong> Se han procesados <strong>{{ listaResult.length }}</strong> {{tipo}}.
            </div>
          </div>
          <div class="col-6">
            <div class="alert {{typeAlert}}" role="alert" *ngIf="procesadoFinalizado">
              <strong>Inserción finalizada:</strong> Se han agregado <strong>{{ agregados }}</strong> {{tipo}}
            </div>
          </div>
        </div>
        
        <ng-container *ngIf="viewErrorTable">
          <h5 class="mt-2 mb-2">
            Errores con la carga masiva de {{tipo | lowercase}}
          </h5>

          <hr class="mb-0">
        
          <app-tabla-view-clientes *ngIf="listaClientes.length > 0" [listaClientes]="listaClientes"></app-tabla-view-clientes>
          <app-tabla-view-maquinas *ngIf="listaMaquinas.length > 0" [listaMaquinas]="listaMaquinas"></app-tabla-view-maquinas>
        </ng-container>
      </div>

      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
            (click)="agregarMasivos.hide()" mdbWavesEffect>
            Cerrar
        </button>
        <button *ngIf="isLoading" class="btn brn-sm btn-secondary" type="button" disabled>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Subiendo...
        </button>
        <button *ngIf="!isLoading" size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect (click)="procesarArchivo()">
            Subir archivo masivo
        </button>
    </div>
    </div>
  </div>
</div>